import React, { useEffect, useState } from 'react';
import {Table, Container, Button} from 'react-bootstrap';
import classes from '../../WebsiteManagement/websiteManagement.module.css';
import Page from '../../pagination/pagination';
import { GetHolidays } from '../../../entities/action/action';

const PackageList = (props)=>{
    const [dataSet,updateDataSet] = useState([]);
    const [count,updateCount] = useState(0)
    const postPerPage = 20;
    const [currentPage,updateCurrentPage] = useState(1);
    const indexOfLast = currentPage*postPerPage;
    const indexOfFirst = indexOfLast - postPerPage;
    const currentPosts = dataSet.slice(indexOfFirst,indexOfLast);
    const handleChangePage = (event,value)=>{
        updateCurrentPage(value)
    }
    useEffect(()=>{
        updateCount(Math.ceil(dataSet.length/postPerPage))
    },[dataSet])

      useEffect(() => {
        (async () => {
          let arr = await GetHolidays();
          if (arr?.success) {
            updateDataSet(arr?.holidays);
          }
        })();
      }, []);
 
    return(
        <Container fluid style={{padding:'0'}}>
            <Table striped bordered hover responsive>
                <thead>
                    <tr>
                        <th>S.No</th>
                        <th>Holiday ID</th>
                        <th>Name</th>
                        <th>Holiday Theme</th>
                        <th>Images</th>
                        <th>Starts On</th>
                        <th>Ends On</th>
                        <th>Category</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        currentPosts.length>0?currentPosts.map((data,key)=>
                            <tr key={key}>
                                <td>{key+1}</td>
                                <td>{data.id}</td>
                                <td>{data.name}</td>
                                <td>{data.theme}</td>
                                <td>{data.images.imageUrl}</td>
                                <td>{data.startDate}</td>
                                <td>{data.endDate}</td>
                                <td>{data.category.categoryName}</td>
                            </tr>
                        ):null
                    }
                </tbody>
            </Table>
            <div style={{display:'flex',justifyContent:'center',margin:'15px 0'}}>
                <Page count={count} change={handleChangePage} page={currentPage}/> 
            </div>
        </Container>
    )
}
export default PackageList;